export class QueryPaths {
    static readonly SpecialBase = process.env.SITECORE_SPECIAL_PAGE_PATH;
    static readonly RetailNTelebet = `${QueryPaths.SpecialBase}/Retail n Telebet`;
    static readonly CustomerServices = `${QueryPaths.SpecialBase}/Customer Services`;
    static readonly BetingInfo = `${QueryPaths.SpecialBase}/Betting Info`;
    static readonly PariMutuelLocalPools = `${QueryPaths.BetingInfo}/Racing/pariMutuelLocalPools`;
    static readonly PariMutuelOutboundComminglingPools = `${QueryPaths.BetingInfo}/Racing/pariMutuelOutboundComminglingPools`;

    // online chanels
    static readonly OnlineChannels = `${QueryPaths.SpecialBase}/Online Channels`;
    static readonly ApplyBet = `${QueryPaths.OnlineChannels}/applybet`;
    static readonly FoundDeposit = `${QueryPaths.OnlineChannels}/FundTransfer/deposit`;
    static readonly FoundWithdrawal = `${QueryPaths.OnlineChannels}/FundTransfer/withdrawal`;
}
